type DiscountTagProps = {
  discount: number;
  isManufacturer?: boolean;
};

/**
 * The DiscountTag component renders the discount tag.
 * @param discount - The discount value.
 * @param isManufacturer - The manufacturer name.
 * @returns a JSX element. It is rendering the discount tag.
 */

export const DiscountTag = ({ discount, isManufacturer }: DiscountTagProps) => {
  if (discount <= 0) return <></>;

  return <div className={`absolute ${isManufacturer ? 'top-[45px]' : 'top-4'} left-3 bg-[#C01010] text-[14px] rounded-sm font-semibold text-white min-[350px]:py-1 px-2`}>{-discount.toFixed(0)}%</div>;
};
